<template>
  <el-form label-position="left" label-width="auto">

    <el-form-item :label="$t('就餐人数')">
      <span>{{recipeDetail.dinnerCount || 0}}</span>
    </el-form-item>

    <el-form-item :label="$t('就餐工具')">
      <div class="tool-box">
        <div class="tool-item" v-for="(item, index) in recipeDetail.cookToolBaseBeans" :key="index">
          <el-image :src="$api.file.downloadImg + item.photo">
            <template #error>
              <div class="flex-center" style="background: #f5f7fa; width: 50px;height: 50px; font-size: 12px;color: #969696">{{ $t('加载失败') }}</div>
            </template>
          </el-image>
          <span>{{ item.name || "" }}</span>
        </div>
      </div>
    </el-form-item>

    <el-form-item :label="$t('口味')">
      <div class="flex" style="column-gap: 16px">
        <an-tag type="primary" v-for="(item, index) in recipeDetail.tasteNames" :key="index">{{ item }}</an-tag>
      </div>
    </el-form-item>

    <el-form-item :label="$t('小贴士')">
      <span>{{ recipeDetail.tips || "" }}</span>
    </el-form-item>

    <el-form-item :label="`${$t('制作难度')}：`">
      <div class="flex" style="column-gap: 16px">
        <an-tag type="primary" v-for="(item, index) in recipeDetail.difficultyNames" :key="index">{{ item }}</an-tag>
      </div>
    </el-form-item>

    <el-form-item :label="`${$t('制作时长')}：`">
      <div class="flex" style="column-gap: 16px">
        <an-tag type="primary" v-for="(item, index) in recipeDetail.durationNames" :key="index">{{ item }}</an-tag>
      </div>
    </el-form-item>

    <!-- 根据更多分类列表渲染   -->
    <!-- 接口返回数据语言自行调整 -->
    <el-form-item v-for="(item, index) in otherCategoryList" :key="index" :label="item.name + '：'">
      <div class="flex" style="column-gap: 16px">
        <an-tag v-for="child in item.sub"
                type="primary"
                :key="child.code">{{ child.name || "" }}</an-tag>
      </div>
    </el-form-item>

    <el-form-item :label="`${$t('菜谱属性')}：`">
      <dict-select flag="RECIPE_ATTRS" v-model="recipeDetail.property" disabled  />
    </el-form-item>

    <el-form-item :label="`${$t('付费金额')}：`">
      <span class="price">￥ {{ recipeDetail.price || 0 }}</span>
    </el-form-item>

  </el-form>
</template>

<script>
import AnTag from "@/components/tag/Tag";
import DictSelect from "@/components/dict/DictSelect";
import {request} from "@/config/request";
export default {
  name: "RecipeStep2",
  components: {DictSelect, AnTag},
  data() {
    return {
      otherCategoryList: [],
    }
  },
  activated() {
    this.loadOtherCategory();
  },
  methods: {
    // 加载其他分类
    async loadOtherCategory() {
      try {
       const res = await request(this.$api.moreSort.list, {onPage: false});
       this.otherCategoryList = res.moreSorts.map(item => {
         item.sub = Array.isArray(item.sub) ? item.sub : [];
         item.sub = item.sub.filter(s => this.moreSortCodeList.includes(s.code))
         return item;
       });
      }catch(e) {
         console.log(e);
      }
    },
  },
  computed: {
    recipeDetail() {
      return this.$store.state.recipeDetail;
    },
    moreSortCodeList() {
      if(!this.recipeDetail?.moreSortCode) return [];
      return this.recipeDetail?.moreSortCode.split(",");
    }
  }
}
</script>

<style scoped>

.tool-box {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.tool-item {
  background: #efefef;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 4px 16px;
  display: flex;
  align-items: center;
  justify-content: center;

}

.el-image {
  width: 50px;
  height: 50px;
  margin-right: 10px;
}

.price {
  font-size: 18px;
  font-weight: bold;
  color: #bd3124;
}

</style>
